'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    padding-left: 25px;\n    padding-right: 30px;\n  '], ['\n    padding-left: 25px;\n    padding-right: 30px;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _colors = require('HubStyleTokens/colors');

var _FormattedJSXMessage = require('I18n/components/FormattedJSXMessage');

var _FormattedJSXMessage2 = _interopRequireDefault(_FormattedJSXMessage);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FooterWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'FooterMicrocopy__FooterWrapper'
})(['position:relative;padding-top:16px;padding-bottom:20px;z-index:1;color:', ';font-size:12px;clear:both;', ''], _colors.SLINKY, _responsiveBreakpoints2.default.tablet(_templateObject));

var FooterMicrocopy = function FooterMicrocopy() {
  var handleClickLink = function handleClickLink() {
    (0, _getUsageTracker2.default)().track('externalLinkClick', {
      name: 'product-services-catalog'
    });
  };

  return _react2.default.createElement(
    FooterWrapper,
    { className: 'text-center flex-column' },
    _react2.default.createElement(_FormattedJSXMessage2.default, {
      message: 'pricingPage.productServicesCatalogPrompt_jsx',
      options: {
        onClick: handleClickLink
      },
      elements: { UILink: _UILink2.default }
    })
  );
};

exports.default = FooterMicrocopy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/FooterMicrocopy.js
// module id = 106
// module chunks = 3 4